import { Observable } from 'rxjs/Observable';
import { Component, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { NgModel } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DazAppointment, DazComplete, DazRemaining, HistoryResponse } from '../models/telemed.model'
import { TelemedService } from '../services/telemed.service'
import { LineStateActionService } from '../statemanagement/line-state-action.service';
@Component({
    selector: 'app-daz-history',
    templateUrl: './daz-history.component.html',
    styleUrls: ['./daz-history.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DazHistoryComponent implements OnInit {

  selectedIndex = signal<number>(0);
  countDazRemaining = signal<number>(0);
  modelsDazRemaining: Array<DazRemaining> = [];
  countDazAppointment = signal<number>(0);
  modelsDazAppointment = signal<Array<DazAppointment>>([]);
  countDazComplete = signal<number>(0);
  modelsDazComplete = signal<Array<DazComplete>>([]);

  constructor(
    private telemedService: TelemedService,
    private lineActionService: LineStateActionService,
    private route: ActivatedRoute,
  ) { }
  ngOnInit() {
    console.info("history init");
    this.setParams();
    console.log("history set params success");
    this.feedData();
    console.log("history data success");
  }

  selectTab(index: number): void {
    this.selectedIndex.set(index);
  }

  setParams() {
    this.route.queryParams
      .subscribe(async (params) => {
        const number = +params.history || 0;
        if (typeof number == "number") {
          this.selectTab(number);
        }
      });
  }

  feedData() {
    const channel = this.lineActionService.channelStateInfo;
    this.telemedService.apiHistory({
      // channel_identity: channel.channel_identity,
      application_channel_reference: channel.application_channel_reference,
      electronic_channel: channel.electronic_channel
    }).subscribe(
      (result: HistoryResponse) => {
        // available
        if (result.available && result.available.length > 0) {
          const groupAvailale = result.available.reduce((r, v) =>
            (r[v.date] = (r[v.date] || 0) + 1, r)
            , {})
          Object.keys(groupAvailale).map(res => {
            this.modelsDazRemaining.push({
              date: this.convertTimestampToDateString(+res),
              count: groupAvailale[res]
            })
            this.countDazRemaining.update(val => val + groupAvailale[res]);
          })
        }
        // usage
        if (result.usage && result.usage.length > 0) {
          this.countDazAppointment.set(result.usage.length);
          result.usage
          .sort((a,b) => a.date-b.date)
          .map(res => {
            const { date, url } = res;
            const datePlus = this.addMinutes(date, 15);
            this.modelsDazAppointment.update(arr => [...arr, {
              date: this.convertTimestampToDateString(date),
              time: this.convertTimestampToTimeString(date) + " น. - " + this.convertTimestampToTimeString(datePlus) + " น.",
              url: url
            }])
          })
        }
        // complete
        if (result.complete && result.complete.length > 0) {
          this.countDazComplete.set(result.complete.length);
          result.complete
          .sort((a,b) => b.date-a.date)
          .map(res => {
            const { date, url } = res;
            const datePlus = this.addMinutes(date, 15);
            this.modelsDazComplete.update(arr => [...arr, {
              date: this.convertTimestampToDateString(date),
              time: this.convertTimestampToTimeString(date) + " น. - " + this.convertTimestampToTimeString(datePlus) + " น.",
              url: url
            }])
          })
        }
        console.log(result)
      },
      error => {
        console.log('feed data error')
        console.error(error)
      }
    )

  }

  convertTimestampToDateString(ts: number): string {
    return new Date(ts).toLocaleDateString('th-TH', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  }
  convertTimestampToTimeString(ts: number): string {
    return new Date(ts).toLocaleTimeString('th-TH', {
      hour: 'numeric',
      minute: 'numeric'
    })
  }

  addMinutes(ts: number, mins: number): number {
    const getMinutes = new Date(ts).getMinutes();
    return new Date(ts).setMinutes(getMinutes + mins);
  }

  clickAppointment(url): void {
    console.log('dazAppointment url', url)
    window.location.href = url;
  }

  clickCompleteInfo(url): void {
    console.log('dazComplete url', url)
    window.location.href = url;
  }

  addClassActive(index: number): string {
    if (index === this.selectedIndex()) {
      return "active"
    }
  }
}
